export const fmtEur = (v) => {
  const n = Math.round(Number(v) || 0);
  const s = Math.abs(n).toLocaleString("fr-FR").replace(/\u00A0/g, "\u202F");
  return `${n < 0 ? "-" : ""}${s}\u202F€`;
};

export const fmtPct = (v, d = 1) =>
  `${(Number(v) || 0).toFixed(d).replace(".", ",")}\u202F%`;

export const parseNum = (str) => {
  if (str === null || str === undefined || str === "") return NaN;
  const clean = String(str)
    .replace(/[\s\u00A0\u202F]/g, "")
    .replace(",", ".");
  const n = Number(clean);
  return Number.isFinite(n) ? n : NaN;
};

export const SIM_LABELS = {
  "louer-vendre": "Louer ou vendre",
  "coloc-simple": "Colocation ou location simple",
  "cash-flow": "Cash-flow locatif",
  "tri-rendement": "TRI vs rendement locatif",
};
